import { render, staticRenderFns } from "./EditBtn.vue?vue&type=template&id=9725ea0e&scoped=true&"
import script from "./EditBtn.vue?vue&type=script&lang=js&"
export * from "./EditBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9725ea0e",
  null
  
)

export default component.exports